import * as React from "react";
import { InboxOutlined, InfoCircleOutlined } from "@ant-design/icons";
import type { UploadProps } from "antd";
import { message, Popover, Upload } from "antd";
const { Dragger } = Upload;

interface DragUploaderProps {
  onFileChange: (file: File | null) => void;
  accept?: string;
  multiple?: boolean;
  maxFiles?: number;
  disabled?: boolean;
  labelText?: string;
  text?: string;
  fileList?: any;
}

export const DragUploader: React.FC<DragUploaderProps> = ({
  accept = ".potx",
  multiple = false,
  maxFiles = 1,
  disabled = false,
  onFileChange,
  fileList,
  labelText = "Upload Template File",
  text = "Upload a .potx file to use as a template for your presentation.",
}) => {
  const props: UploadProps = {
    name: "file",
    fileList,
    accept,
    multiple,
    disabled,
    maxCount: maxFiles,
    beforeUpload: (file) => {
      const isValid = file.name.toLowerCase().endsWith(".potx");

      if (!isValid) {
        message.error("Only .potx files are allowed!");
        return Upload.LIST_IGNORE; // Reject the file
      }

      onFileChange(file);
      return false;
    },
    onChange(info) {
      const { status } = info.file;
      if (status === "done") {
        message.success(`${info.file.name} file loaded.`);
      } else if (status === "error") {
        message.error(`${info.file.name} failed to load.`);
      }
    },
    onRemove() {
      onFileChange(null);
    },
    showUploadList: {
      showRemoveIcon: true,
    },
  };

  return (
    <>
      <label style={{ fontWeight: "bold" }}>
        {labelText}{" "}
        {text && (
          <Popover content={text} trigger="click" overlayStyle={{ width: 400 }}>
            <InfoCircleOutlined style={{ cursor: "pointer" }} />
          </Popover>
        )}
      </label>
      <Dragger {...props}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">Presentation Template (.potx file)</p>
        <p className="ant-upload-hint">
          Support for a single file. Only .potx files are accepted. with max size of 5MB
        </p>
      </Dragger>
    </>
  );
};
